import { Link } from "react-router-dom";

/**
 * PostShifted logo: coral rounded-square with a white play-triangle + small
 * vertical bar inside. Matches the brand mark used on the marketing image.
 */
export function LogoGlyph({ size = 22, className = "" }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      aria-hidden="true"
    >
      <rect width="32" height="32" rx="7" fill="#FF5B4A" />
      <path d="M9 8L20 16L9 24V8Z" fill="#FFFFFF" />
      <path d="M23 8V24" stroke="#FFFFFF" strokeWidth="2.4" strokeLinecap="round" />
    </svg>
  );
}

export default function Logo({ to = "/", className = "" }) {
  return (
    <Link
      to={to}
      data-testid="brand-logo"
      className={`group inline-flex items-center gap-2.5 ${className}`}
    >
      <LogoGlyph
        size={22}
        className="transition-transform duration-300 group-hover:-translate-y-[1px] group-hover:rotate-[-4deg]"
      />
      <span className="font-serif text-xl font-semibold tracking-tight text-neutral-900">
        PostShifted<span className="text-coral">.</span>
      </span>
    </Link>
  );
}
